import { useEffect, useState } from "react";

import { GetAllUsersResponse, UserFromApi } from "@/types/user";

import { useApi } from "../useApi";

const useAdminGetUsers = () => {
  const [items, setItems] = useState<UserFromApi[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { apiGet } = useApi({ isAdmin: true });

  useEffect(() => {
    const getAllUsers = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiGet<GetAllUsersResponse>("/admin/users");
        if (response?.users) {
          setItems(response.users);
        } else {
          setError("Failed to load users");
        }
      } catch (error) {
        console.error(error);
        setError("Failed to load users");
      } finally {
        setLoading(false);
      }
    };
    // Initial load of users.
    getAllUsers();
  }, [apiGet]);

  return {
    items,
    loading: loading,
    error,
  };
};

export default useAdminGetUsers;
